import { ColumnDef } from '@tanstack/react-table';
import { useState } from 'react';
import { Stack } from 'react-bootstrap';
import ConfirmationModal from '../../../components/modals/ConfirmationModal';
import { LinkCell } from '../../../components/tables/cellComponents/LinkCell';
import { useToast } from '../../../context/ToastContext';
import { useDeleteFoodHistoryMutation } from '../../../services/endpoints/content/foodHistories';
import { Document } from '../../../types/content.type';
import { getErrorMessage } from '../../utils';

const DeleteFoodHistoryButton: React.FC<{ id: number }> = ({ id }) => {
  const [showModal, setShowModal] = useState(false);
  const [deleteFoodHistory, { isLoading }] = useDeleteFoodHistoryMutation();
  const { addToast } = useToast();

  const handleDelete = async () => {
    try {
      await deleteFoodHistory(id).unwrap();
      addToast('Food history deleted successfully', 'success');
      setShowModal(false);
    } catch (e) {
      addToast(getErrorMessage(e), 'error');
    }
  };

  return (
    <>
      <button
        className="text-info fw-bolder btn btn-link p-0"
        style={{ fontSize: '.875rem', textDecoration: 'underline' }}
        onClick={() => setShowModal(true)}
      >
        Delete
      </button>
      <ConfirmationModal
        show={showModal}
        title="Delete Food History"
        message="Are you sure you want to delete this food history?"
        confirmText="Yes, Delete"
        cancelText="Cancel"
        onConfirm={handleDelete}
        onCancel={() => setShowModal(false)}
        isLoading={isLoading}
      />
    </>
  );
};

export const foodHistoriesColumns: ColumnDef<Document>[] = [
  {
    header: 'ID',
    accessorKey: 'id',
    cell: ({ getValue }) => (
      <LinkCell
        content={getValue<number>()}
        url={`/admin/content/food-histories/${getValue<number>()}`}
      />
    )
  },
  {
    header: 'Name',
    accessorKey: 'name'
  },

  {
    header: () => null,
    id: 'actions',
    enableSorting: false,
    cell: ({ row }) => (
      <Stack
        direction="horizontal"
        gap={2}
      >
        <LinkCell
          content="View"
          url={`/admin/content/food-histories/${row.original.id}`}
          underline
        />
        <LinkCell
          content="Edit"
          url={`/admin/content/food-histories/${row.original.id}/edit`}
          underline
        />
        <DeleteFoodHistoryButton id={row.original.id} />
      </Stack>
    )
  }
];
